export default "__VITE_ASSET__X4vaQYro__"